import classNames from "classnames";

/*
 * This component is used to display an error message following HappyDoc styles.
 */
function ErrorBox({ msg }: { msg: string }) {
    return (
        <div
            className={classNames(
                "flex w-full py-3 mt-2 px-2 items-center justify-center gap-4 bg-red-50",
                "border-l-[6px] border-t-[1px] border-b-[1px] border-r-0 border-red-600",
            )}
        >
            <span className={classNames("text-xs font-medium ", "text-red-900")}>{msg}</span>
        </div>
    );
}

export default ErrorBox;
